<template lang="html">
  <div class="create-profile-wrapper">
    <div class="form-progress-wrap edit-profile basic-info-wrap">
      <div class="container">
        <div class="steps-content">
          <div class="general-form-wrap player-detail-form-wrap box-wrapper">
            <div class="heading">
              <h2 class="form-title">
                {{
                  workingTypeNew
                    ? "Add New Coach"
                    : `Edit ${coach.name} Details`
                }}
              </h2>
            </div>
            <div class="coach-edit-form">
              <BaseDragUpload
                cannot-delete
                label="Click this area to upload or change photo"
                class="drag-upload-class"
                :image-url="coach.profileImage"
                @file-upload="
                  image => {
                    imageSrc = image;
                    imageUrl = image;
                  }
                "
              />
              <div class="relative-position-coach">
                <FormModel
                  class="coach-form-wrapper"
                  :model="coach"
                  :rules="validationRules"
                  ref="form"
                  @submit.prevent.native="handleFormSubmit"
                >
                  <a-row :gutter="32">
                    <a-col :sm="24" :md="12">
                      <BaseFormInput
                        :value="coach.coachname"
                        label="Coach Name"
                        placeholder="Enter Name"
                        @change="
                          event => handleFormValueChange(event, 'coachname')
                        "
                        name="coachname"
                      />
                    </a-col>
                    <a-col :sm="24" :md="12">
                      <BaseFormInput
                        :value="coach.staffPhone"
                        label="Phone Number"
                        placeholder="Enter Phone Number"
                        @change="
                          event => handleFormValueChange(event, 'staffPhone')
                        "
                        name="staffPhone"
                        v-if="true"
                        type="text"
                      />
                    </a-col>
                    <a-col :sm="24" :md="12">
                      <BaseFormInput
                        :value="coach.email"
                        label="Email"
                        type="email"
                        placeholder="Enter Email"
                        @change="event => handleFormValueChange(event, 'email')"
                        name="email"
                        v-if="workingTypeNew"
                      />
                    </a-col>
                    <a-col :sm="24" :md="12">
                      <BaseFormInput
                        :value="coach.position"
                        label="Position"
                        placeholder="Enter Position"
                        @change="
                          event => handleFormValueChange(event, 'position')
                        "
                        name="position"
                      />
                    </a-col>
                    <a-col :sm="24" :md="12">
                      <BaseSelect
                        :value="coach.role || undefined"
                        label="Role"
                        name="role"
                        labelPath="label"
                        valuePath="value"
                        placeholder="Select role"
                        @change="value => handleSelect(value, 'role')"
                        :items="coachRoles"
                        v-if="workingTypeNew"
                      />
                    </a-col>
                    <a-col :sm="24">
                      <BaseFormInput
                        :value="coach.description"
                        label="Description"
                        placeholder="Enter Description"
                        @change="
                          event => handleFormValueChange(event, 'description')
                        "
                        name="description"
                        type="textarea"
                      />
                    </a-col>
                    <!-- <a-col :sm="24" :md="8">
                      <BaseFormInput
                        :value="coach.facebook"
                        label="Facebook"
                        placeholder="Enter Description"
                        @change="
                          event => handleFormValueChange(event, 'facebook')
                        "
                        name="facebook"
                      />
                    </a-col>
                    <a-col :sm="24" :md="8">
                      <BaseFormInput
                        :value="coach.instagram"
                        label="Instagram"
                        placeholder="Enter instagram"
                        @change="
                          event => handleFormValueChange(event, 'instagram')
                        "
                        name="instagram"
                      />
                    </a-col>
                    <a-col :sm="24" :md="8">
                      <BaseFormInput
                        :value="coach.twitter"
                        label="Twitter"
                        placeholder="Enter twitter"
                        @change="
                          event => handleFormValueChange(event, 'twitter')
                        "
                        name="twitter"
                      />
                    </a-col>
                    <a-col :sm="24" :md="8">
                      <BaseFormInput
                        :value="coach.linkedin"
                        label="Linkedin"
                        placeholder="Enter linkedin"
                        @change="
                          event => handleFormValueChange(event, 'linkedin')
                        "
                        name="linkedin"
                      />
                    </a-col>
                    <a-col :sm="24" :md="8">
                      <BaseFormInput
                        :value="coach.youtube"
                        label="Youtube"
                        placeholder="Enter youtube"
                        @change="
                          event => handleFormValueChange(event, 'youtube')
                        "
                        name="youtube"
                      />
                    </a-col>
                    <a-col :sm="24" :md="8">
                      <BaseFormInput
                        :value="coach.podcast"
                        label="Podcast"
                        placeholder="Enter podcast"
                        @change="
                          event => handleFormValueChange(event, 'podcast')
                        "
                        name="podcast"
                      />
                    </a-col> -->
                  </a-row>
                  <div class="footer-button-wrapper">
                    <div class="submit-button">
                      <BaseButton
                        type="primary"
                        html-type="submit"
                        :loading="coachLoading"
                      >
                        {{ workingTypeEdit ? "Update" : "Create New" }}
                      </BaseButton>
                    </div>
                  </div>
                </FormModel>
                <div class="extra-buttons">
                  <BaseButton
                    type="danger"
                    @click="backToList"
                    class="first-child-wrapper"
                  >
                    Back to List
                  </BaseButton>
                  <BaseButton
                    type="danger"
                    @click="togglePostActionModalDelete"
                    class="first-child-wrapper"
                    v-if="workingTypeEdit && isNotSelf"
                  >
                    Delete
                  </BaseButton>
                  <BaseButton
                    type="danger"
                    @click="togglePostActionModal"
                    v-if="workingTypeEdit && isNotSelf && coach.lastLogin"
                  >
                    {{ coach.isActive ? "Deactivate" : "Activate" }}
                  </BaseButton>
                </div>
              </div>
            </div>
            <BaseModal
              class="modal-wrapper"
              title="Deactivate Coach"
              :visible="postActionModal"
              ok-text="Yes"
              cancel-text="No"
              :closable="false"
              @ok="handleModalSubmit"
              @cancel="togglePostActionModal"
              :ok-button-props="{
                props: { disabled: reason ? false : true }
              }"
            >
              <div slot="content">
                <p>Are you sure you want to deactivate ?</p>
                <a-textarea
                  :auto-size="{ minRows: 4, maxRows: 5 }"
                  :value="reason"
                  placeholder="Enter Deactivate Reason"
                  @change="event => handleModalValueChange(event, 'reason')"
                />
              </div>
            </BaseModal>
            <BaseModal
              class="modal-wrapper"
              title="Delete Coach"
              :visible="postActionModalDelete"
              ok-text="Yes"
              cancel-text="No"
              :closable="false"
              @ok="handleModalSubmitDelete"
              @cancel="togglePostActionModalDelete"
            >
              <div slot="content">
                <p>Are you sure you want to Delete ?</p>
              </div>
            </BaseModal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Coach } from "@/models";
import { FormModel } from "ant-design-vue";
import { mapGetters } from "vuex";

const COACH_STORE_KEY = "coachStore";

export default {
  components: {
    FormModel
  },
  data() {
    return {
      coach: new Coach(this.resource),
      validationRules: Coach.validationRules,
      postActionModal: false,
      postActionModalDelete: false,
      reason: "",
      imageSrc: "",
      imageUrl: "",
      coachRoles: Coach.coachRoles
    };
  },
  props: {
    resource: {
      type: Object,
      default: () => ({})
    },
    workingType: {
      type: String,
      default: "edit"
    }
  },
  computed: {
    ...mapGetters({
      coachLoading: `${COACH_STORE_KEY}/coachLoading`,
      storeCoach: `${COACH_STORE_KEY}/coach`
    }),
    workingTypeEdit() {
      return this.workingType === "edit";
    },
    workingTypeNew() {
      return this.workingType === "new";
    },
    profileId() {
      return Coach.profileId();
    },
    isNotSelf() {
      return this.profileId !== this.coach.id;
    }
  },
  methods: {
    backToList() {
      this.$router.push(`/${this.profileId}/college_profile/coaching_staffs`);
    },
    handleSelect(value, key) {
      this.coach = new Coach({ ...this.coach, [key]: value });
    },
    async handleModalSubmit() {
      await this.$store.dispatch(`${COACH_STORE_KEY}/toggleActivation`, {
        coachId: this.coach.coachId,
        isActive: !this.coach.isActive,
        dReason: this.reason,
        flag: "deActivate",
        CollegeId: this.coach.collegeId
      });
      this.$router.push(`/${this.profileId}/college_profile/coaching_staffs`);
    },
    async editFormSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          await this.$store.dispatch(`${COACH_STORE_KEY}/updateCoach`, {
            id: this.coach.key,
            coachname: this.coach.coachname,
            text: this.coach.text,
            description: this.coach.description,
            facebook: this.coach.facebook,
            instagram: this.coach.instagram,
            twitter: this.coach.twitter,
            linkedin: this.coach.linkedin,
            youtube: this.coach.youtube,
            podcast: this.coach.podcast,
            role: this.coach.role,
            staffPhone: this.coach.staffPhone,
            position: this.coach.position,
            slug: "editcollegecoach"
          });
          let formData = new FormData();
          formData.append("file", this.imageSrc);
          this.imageSrc &&
            (await this.$store.dispatch(`${COACH_STORE_KEY}/uploadImage`, {
              id: this.storeCoach.id,
              image: formData
            }));
          this.$router.push(
            `/${this.profileId}/college_profile/coaching_staffs`
          );
        }
      });
    },
    async newFormSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          await this.$store.dispatch(`${COACH_STORE_KEY}/createCoach`, {
            coachname: this.coach.coachname,
            position: this.coach.position,
            text: this.coach.text,
            description: this.coach.description,
            staffPhone: this.coach.staffPhone,
            email: this.coach.email,
            facebook: this.coach.facebook,
            instagram: this.coach.instagram,
            twitter: this.coach.twitter,
            linkedin: this.coach.linkedin,
            youtube: this.coach.youtube,
            podcast: this.coach.podcast,
            role: this.coach.role,
            CollegeId: localStorage["college-id"],
            slug: "collegecoach"
          });
          let formData = new FormData();
          formData.append("file", this.imageSrc);
          this.imageSrc &&
            (await this.$store.dispatch(`${COACH_STORE_KEY}/uploadImage`, {
              id: this.storeCoach.id,
              image: formData
            }));
          this.$router.push(
            `/${this.profileId}/college_profile/coaching_staffs`
          );
        }
      });
    },
    togglePostActionModalDelete() {
      this.postActionModalDelete = !this.postActionModalDelete;
    },
    async handleModalSubmitDelete() {
      await this.$store.dispatch(`${COACH_STORE_KEY}/deleteCoach`, {
        slug: "collegecoach",
        coachId: this.coach.coachId,
        CollegeId: this.coach.collegeId,
        isDeleted: true
      });
      this.$router.push(`/${this.profileId}/college_profile/coaching_staffs`);
    },
    togglePostActionModal() {
      this.postActionModal = !this.postActionModal;
    },
    handleModalValueChange(e, key) {
      this[key] = e.target.value;
    },
    handleFormValueChange(e, key) {
      this.coach = new Coach({ ...this.coach, [key]: e.target.value });
    },
    handleFormSubmit() {
      this.workingTypeEdit ? this.editFormSubmit() : this.newFormSubmit();
    }
  },
  watch: {
    resource(newVal, _) {
      this.coach = new Coach(newVal);
      this.imageUrl = newVal.profileImage;
    }
  }
};
</script>

<style lang="scss">
.coach-edit-form {
  .footer-button-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
  }
  .extra-buttons {
    display: flex;
    justify-content: space-evenly;
    float: right;
    margin-bottom: 1rem;
    .first-child-wrapper {
      margin-right: 8px;
    }
  }
}
@media only screen and (max-width: 575px) {
  .coach-edit-form {
    .footer-button-wrapper {
      justify-content: center;
      flex-direction: column;
    }
    .extra-buttons {
      margin-top: 20px;
      display: flex;
      justify-content: space-evenly;
      float: right;
      margin-bottom: 1rem;
    }
  }
}
</style>
